// Verificar si el usuario está autenticado
export function isAuthenticated() {
    const token = localStorage.getItem('authToken');
    return !!token;
}

// Obtener información del usuario
export function getUser() {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
}

// Verificar si el usuario tiene permisos de administrador
export function isAdmin() {
    const user = getUser();
    return user && user.role === 'admin';
}

// Cerrar sesión
export function logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('rememberMe');
}

// Guard de navegación para rutas protegidas
export function requireAuth(to, from, next) {
    if (!isAuthenticated()) {
        next('/login');
    } else {
        next();
    }
}

// Guard para redirigir usuarios autenticados desde login
export function redirectIfAuthenticated(to, from, next) {
    if (isAuthenticated()) {
        next('/dashboard');
    } else {
        next();
    }
} 